import { createIcon } from '../createIcon';

export const OutlinedHddIconConfig = {
  name: 'OutlinedHddIcon',
  height: 512,
  width: 576,
  svgPath: 'M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z',
  yOffset: 0,
  xOffset: 0,
};

export const OutlinedHddIcon = createIcon(OutlinedHddIconConfig);

export default OutlinedHddIcon;